/**
 * @description
 * The 'img' role is used to identify an element as image. Alt attribute have to be provided on status component.
 *
 * @specification
 * Adds role='img'.
 */
export var statusBehavior = function statusBehavior() {
  return {
    attributes: {
      root: {
        role: 'img'
      }
    }
  };
};